import { isNil } from 'lodash'

/**
 * Retrieval weight on a knowledge-base connection allowlist entry.
 *
 * Neither panel shows or edits it, but both forms rebuild the whole allowlist
 * on save and this JSON is the only place a weight is stored, so the forms
 * carry it through untouched and leave validation to the server. Unweighted
 * stays an ABSENT key, so an untouched allowlist round-trips byte-identical.
 */
export const carriedWeight = (entry) => (isNil(entry.weight) ? {} : { weight: entry.weight })
